import { ChatModuleType } from 'app/copied/models/ChatModules';

import useModule from './useModule';

function useIndicationSelector() {
  const indicationSelectorModule = useModule(ChatModuleType.IndicationSelector);
  const getSelectedIndication = () =>
    indicationSelectorModule?.items?.find(
      (item) => item.hub_condition_uuid === localStorage.getItem('rx_condition_id')
    );

  return {
    indicationSelectorModule,
    getSelectedIndication,
    primaryIndicationSelectorEnabled: indicationSelectorModule?.primary_selector_enabled,
    secondaryIndicationSelectorEnabled: indicationSelectorModule?.secondary_selector_enabled,
  };
}

export default useIndicationSelector;
